// User roles enum
export const UserRoles = {
  SUPER_ADMIN: 'super_admin',
  CORPORATE: 'corporate',
  ADMIN: 'admin',
  MANAGEMENT: 'management',
  TENANT: 'tenant',
} as const

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles]

/** The one set of role names people see (Team role list, accept page, member page) */
export const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: 'Super Admin',
  corporate: 'Corporate',
  admin: 'Admin',
  management: 'Management',
  tenant: 'Tenant',
}

export const roleLabel = (role: string): string =>
  ROLE_LABELS[role as UserRole] ?? role

// Account modes for role system operation
export const AccountModes = {
  SIMPLE: 'simple',
  PRO: 'pro',
  ENTERPRISE: 'enterprise',
} as const

export type AccountMode = (typeof AccountModes)[keyof typeof AccountModes]

// Privilege escalation types for Manager+Admin functionality
export const PrivilegeTypes = {
  ADMIN_READ: 'admin_read',
  ADMIN_WRITE: 'admin_write',
  BILLING_ACCESS: 'billing_access',
  USER_MANAGEMENT: 'user_management',
  PROPERTY_CREATION: 'property_creation',
} as const

export type PrivilegeType = (typeof PrivilegeTypes)[keyof typeof PrivilegeTypes]
